<div class="flex items-center justify-between gap-x-6 py-3.5">
  <div class="min-w-0">
    <div class="flex items-start gap-x-3">
      <p class="text-sm font-semibold leading-6 text-gray-900">
        #{{ order.id }} {{ order.customer.firstname }} {{ order.customer.lastname }}
      </p>
      @if (!editStatus) {
        <p
          [ngClass]="getStatusClass(order.status)"
          class="rounded-md whitespace-nowrap mt-0.5 px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset"
          >
          {{ order.status }}
        </p>
      }
      @if (editStatus) {
        <div>
          <form [formGroup]="statusForm">
            <label for="status" class="block text-sm font-medium leading-6 text-gray-900">Statut</label>
            <select
              id="status"
              name="status"
              formControlName="status"
              class="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-stone-600 sm:text-sm sm:leading-6"
              >
              @for(status of saleStatus | keyvalue; track status) {
                <option ng-model="status" value="{{ status.key }}">
                  {{ status.value }}
                </option>
              }
            </select>
          </form>
        </div>
      }
    </div>
    <p>Numéro de commande : {{ order.order_tracking_number }}</p>
    <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
      <p class="whitespace-nowrap">
        Commande passée le
        <time [attr.datetime]="order.createdAt">{{ order.createdAt }}</time>
      </p>
    </div>
  </div>
  <div class="flex flex-none items-center gap-x-4">
    @if (!editStatus) {
      <a
        (click)="toggleStatus()"
        class="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
        >
        Modifier le status
      </a>
    }
    @if (editStatus) {
      <a
        (click)="toggleStatus()"
        class="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
        >
        Annuler
      </a>
    }
    @if (editStatus) {
      <a
        (click)="saveStatus(order.id)"
        class="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
        >
        Sauvegarder
      </a>
    }
    @if (!editStatus) {
      <a
        (click)="toggleDetails()"
        class="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
        >
        Détails
      </a>
    }

    <div class="relative flex-none">
      <!--      <button (click)="toggleMenu()" type="button" class="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900" id="options-menu-0-button" aria-expanded="false" aria-haspopup="true">-->
      <!--        <span class="sr-only">Open options</span>-->
      <!--        <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">-->
      <!--          <path d="M10 3a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM10 8.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM11.5 15.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" />-->
    <!--        </svg>-->
  <!--      </button>-->

  <!--
  Dropdown menu, show/hide based on menu state.

  Entering: "transition ease-out duration-100"
  From: "transform opacity-0 scale-95"
  To: "transform opacity-100 scale-100"
  Leaving: "transition ease-in duration-75"
  From: "transform opacity-100 scale-100"
  To: "transform opacity-0 scale-95"
  -->
  @if (isMenu) {
    <div
      @AnimationTrigger0
      class="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu-0-button"
      tabindex="-1"
      >
      <!-- Active: "bg-gray-50", Not Active: "" -->
      <a
        href="#"
        class="block px-3 py-1 text-sm leading-6 text-gray-900"
        role="menuitem"
        tabindex="-1"
        id="options-menu-0-item-0"
        >
        Voir
        <span class="sr-only">, commande {{ order.id }}</span>
      </a>
      <a
        href="#"
        class="block px-3 py-1 text-sm leading-6 text-gray-900"
        role="menuitem"
        tabindex="-1"
        id="options-menu-0-item-1"
        >
        <span class="sr-only">, commande {{ order.id }}</span>
      </a>
      <!--        <a href="#" class="block px-3 py-1 text-sm leading-6 text-gray-900" role="menuitem" tabindex="-1" id="options-menu-0-item-2">-->
      <!--          Supprimer<span class="sr-only">, commande {{order.id}}</span></a>-->
    </div>
  }
</div>
</div>
</div>
@if (isDetail) {
  <div @AnimationTrigger0 class="mb-8">
    <div class="-mx-4 mt-2 sm:-mx-0">
      <table class="min-w-full divide-y">
        <thead>
          <tr>
            <th scope="col" class="py-3.5 text-left text-xs font-semibold text-gray-900">Informations générales</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr>
            <td class="whitespace-nowrap py-4 text-sm text-gray-500">
              {{ order.customer.firstname }} {{ order.customer.lastname }}
              <br />
              {{ order.customer.phone }}
              <br />
              {{ order.customer.email }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="-mx-4 mt-2 sm:-mx-0">
      <table class="min-w-full divide-y">
        <thead>
          <tr>
            <th scope="col" class="py-3.5 text-left text-xs font-semibold text-gray-900">Adresse de Facturation</th>
            <th scope="col" class="py-3.5 text-left text-xs font-semibold text-gray-900">Adresse de Livraison</th>
          </tr>
        </thead>
        @if (isPickupDeliveryType()) {
          <tbody class="divide-y divide-gray-200 bg-white">
            <tr>
              <td class="whitespace-nowrap py-4 text-sm text-gray-500">
                <table>
                  <tr>
                    <td>Customer will pickup package at the shop directly</td>
                  </tr>
                </table>
              </td>
              <td class="whitespace-nowrap py-4 text-sm text-gray-500">
                <table>
                  <tr>
                    <td>Customer will pickup package at the shop directly</td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        } @else {
          <tbody class="divide-y divide-gray-200 bg-white">
            <tr>
              <td class="whitespace-nowrap py-4 text-sm text-gray-500">
                <table>
                  <tr>
                    <td>Street</td>
                    <td>{{ order.invoiceAddress.street }} {{ order.invoiceAddress.number }}</td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>{{ order.invoiceAddress.ZIP }} {{ order.invoiceAddress.city }}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{{ order.invoiceAddress.state }}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{{ order.invoiceAddress.country }}</td>
                  </tr>
                </table>
              </td>
              <td class="whitespace-nowrap py-4 text-sm text-gray-500">
                <table>
                  <tr>
                    <td>Street</td>
                    <td>{{ order.deliveryAddress.street }} {{ order.deliveryAddress.number }}</td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>{{ order.deliveryAddress.ZIP }} {{ order.deliveryAddress.city }}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{{ order.deliveryAddress.state }}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{{ order.deliveryAddress.country }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        }
      </table>
    </div>
    <div class="-mx-4 mt-2 sm:-mx-0">
      <table class="min-w-full divide-y divide-gray-300">
        <thead>
          <td class="text-xs font-semibold text-gray-900">Qauntity</td>
          <td class="text-xs font-semibold text-gray-900">Article</td>
          <td class="text-xs px-3 font-semibold text-gray-900">Color</td>
          <td class="text-xs px-3 font-semibold text-gray-900">Size</td>
          <td class="text-xs px-3 font-semibold text-gray-900">Price</td>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          @for(article of order.items; track article) {
            <tr>
              <td>{{ article.quantity }}</td>
              <td class="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-0">
                <!-- <img class="inline-block h-8 w-8 rounded-md" src="" alt="" /> -->
                {{ article.product.brand }} - {{ article.product.name }}
                <dl class="font-normal lg:hidden">
                  <dd class="mt-1 truncate text-gray-700">{{ article.color.name }}</dd>
                  <dd class="mt-1 truncate text-gray-500 sm:hidden">{{ article.size.name }}</dd>
                </dl>
              </td>
              <td class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">{{ article.color.name }}</td>
              <td class="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">{{ article.size.name }}</td>
              <td class="px-3 py-4 text-sm text-gray-500">{{ article.product.price * article.quantity }} CHF</td>
            </tr>
          }
          <tr>
            <td colspan="4">Total</td>
            <td class="px-3">{{ order.totalPrice }} CHF</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
}
